import { inject, Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { filter, map, tap } from 'rxjs/operators';

import { featureFlagsActions, HasFeatureFlagFacade } from '@kros-sk/core/feature-flags';

import * as authActions from './auth.actions';
import { KrosAuthService } from '../services/auth/kros-auth.service';
import { LOAD_FEATURE_FLAGS_IN_AUTH } from '../kros-auth.config';

@Injectable()
export class AuthEffects {
  private readonly actions$ = inject(Actions);
  private readonly authService = inject(KrosAuthService);
  private readonly hasFeatureFlagFacade = inject(HasFeatureFlagFacade, { optional: true });
  private readonly doLoadFeatureFlags = inject(LOAD_FEATURE_FLAGS_IN_AUTH);

  startAuthentication$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(authActions.startAuthentication),
        tap(() => this.authService.startAuthentication())
      );
    },
    { dispatch: false }
  );

  logoutUser$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(authActions.logoutUser),
        tap(() => {
          this.authService.logOut();
          if (localStorage) {
            localStorage.removeItem('redirectUrl');
          }
        })
      );
    },
    { dispatch: false }
  );

  loadFeaturesAfterLogin$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(authActions.setUser),
      filter(() => this.hasFeatureFlagFacade !== null && this.doLoadFeatureFlags),
      map(() => featureFlagsActions.loadFeatures())
    );
  });
}
